import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

interface TemplateChannelParamCollectionOptions {
    sensorType: number
    sensorVersion: number
}

export class TemplateChannelParamCollection extends CachingCollection<Backbone.Model> {

    sensorType: number;
    sensorVersion: number;

    constructor(initialModels: Object[] | any[], options: TemplateChannelParamCollectionOptions) {
        super(initialModels, options);
        this.sensorType = options.sensorType;
        this.sensorVersion = options.sensorVersion;
    }

    url = () => {
        return window.location.origin + '/api/v1/templates/channelparams/' + this.sensorType + '/' + this.sensorVersion;
    };

    comparator = (model) => {
        return model.get('name');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/TemplateChannelParams.ts